export default [
  'viewControlsOverlay',
  'searchOverlay',
  'menuOverlay',
  'zoomOverlay',
  'toolsOverlay',
  'toolStylePopup',
  'stampOverlay',
  'signatureOverlay',
  'measurementOverlay'
];